import React from 'react';
import { Avatar, Button, Dialog, DialogContent, Typography, PaletteColor, DialogTitle, IconButton, DialogActions, Stack, Box } from '@mui/material';
import { theme } from '../../../theme';
import CloseIcon from '@mui/icons-material/Close';

interface ConfirmationDialogProps {
  open: boolean;
  icon: React.ReactElement;
  variant?: 'bad' | 'primary';
  iconBgColor?: PaletteColor;
  iconColor?: PaletteColor;
  title: string;
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  icon,
  variant = 'bad',
  iconBgColor = theme.palette.error,
  iconColor = theme.palette.error,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    fullWidth
    maxWidth='sm'
    open={open}
    onClose={onCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    sx={{
      '& .MuiDialog-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    }}
  >
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          sx={{
            backgroundColor: iconBgColor[100],
            color: iconColor[700],
          }}
        >
          {icon}
        </Avatar>
      </Box>

      <IconButton
        onClick={onCancel}
        sx={{
          color: (theme) => theme.palette.custom.gray[800],
          mr: '-10px',
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent>
      <Stack>
        <Typography variant='textLG'
          fontWeight={600}>{title}</Typography>
        <Typography color="textSecondary"
          sx={{ mt: 1 }}
          variant="textSM">
          {message}
        </Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Stack direction={{ xs: 'column', md: 'row' }}
        gap='6px'
        width='100%'>
        <Button
          fullWidth
          variant="secondary"
          size="md"
          onClick={onCancel}>
          {cancelButtonText}
        </Button>
        <Button
          fullWidth
          variant={variant}
          size="md"
          onClick={onConfirm}
        >
          {confirmButtonText}
        </Button>
      </Stack>
    </DialogActions>
  </Dialog >
);
